import {
  CULTURE_PREFERENCE_TEXT,
  CULTURE_PREFERENCE_TEXT_OPTION,
} from '@/constants/profile-builder';
import { STORAGE_NAME } from '@/components/wenhua/QuizQuestion';
import {
  CULTURE_PREFERENCE,
  CULTURE_PREFERENCE_CHOICES,
  CULTURE_PREFERENCE_SCORE,
  CULTURE_PREFERENCE_TYPE,
} from '@/constants/culture-preference';
import { getLocalStorage, removeLocalStorage } from '@/utils/storage';
import { updateJobSeekerProfile } from '@/api/tanzhi';

export const getCulturePreferenceResult = (data: number[][]) => {
  const scoreObj = {
    E: 0,
    I: 0,
    F: 0,
    C: 0,
  };

  data?.map((item, index) => {
    const findIndex = item.findIndex((value) => value === 1);
    if (findIndex > -1 && findIndex < 2) {
      const selectedKey = CULTURE_PREFERENCE_TEXT_OPTION[index][findIndex];
      scoreObj[selectedKey as keyof typeof scoreObj] += 1;
    }
  });

  const xAxisScore = Object.values(scoreObj).slice(0, 2);
  const yAxisScore = Object.values(scoreObj).slice(2);
  const areaObj = {
    A: xAxisScore[0] * yAxisScore[0],
    C: xAxisScore[1] * yAxisScore[0],
    H: xAxisScore[1] * yAxisScore[1],
    M: xAxisScore[0] * yAxisScore[1],
  };
  const sortAreaObjKeys = Object.keys(areaObj).sort(
    (k1, k2) => Reflect.get(areaObj, k2) - Reflect.get(areaObj, k1),
  );

  const isXAxisMultiCase =
    (xAxisScore.includes(6) && xAxisScore.includes(9)) ||
    (xAxisScore.includes(7) && xAxisScore.includes(8));
  const isYAxisMultiCase =
    (yAxisScore.includes(6) && yAxisScore.includes(9)) ||
    (yAxisScore.includes(7) && yAxisScore.includes(8));

  const _teamTypePreference =
    sortAreaObjKeys
      .slice(
        0,
        (isXAxisMultiCase && isYAxisMultiCase) ||
          (!isXAxisMultiCase && !isYAxisMultiCase)
          ? 1
          : 2,
      )
      .join('') || '';
  const _teamTypePreferenceScore = Reflect.get(areaObj, sortAreaObjKeys[0]);

  return {
    _teamTypePreference,
    _teamTypePreferenceScore,
    _culturePreferenceScore: scoreObj,
  };
};

export const validatorData = (
  data: number[][],
  text: { title: string; options: string[] }[],
) => {
  let flag = false;
  if (data.length === text.length && text.length > 0) {
    for (const index in data) {
      const options = data[index];
      const textOptions = text[index].options;
      const optionsLength = options.length;
      const zeroNumbers = options.filter((item) => item === 0).length;
      const oneNumbers = options.filter((item) => item === 1).length;
      if (
        optionsLength === textOptions.length &&
        optionsLength > 0 &&
        (zeroNumbers === optionsLength ||
          (zeroNumbers === 1 && oneNumbers === 1))
      ) {
        flag = true;
      } else {
        flag = false;
        break;
      }
    }
  }
  return flag;
};

export const getLocalStorageData = () => {
  const storageData = getLocalStorage(STORAGE_NAME);
  const culturePreferenceData = storageData ? JSON.parse(storageData) : null;
  const handleValidate = (value: number[][]) => {
    const validValue = value.filter(
      (item) => item.includes(1) && item.includes(0),
    );
    return validValue.length === value.length;
  };
  const isValidData =
    culturePreferenceData &&
    validatorData(culturePreferenceData, CULTURE_PREFERENCE_TEXT) &&
    handleValidate(culturePreferenceData);
  if (isValidData) {
    const { _teamTypePreference, _teamTypePreferenceScore } =
      getCulturePreferenceResult(culturePreferenceData);
    return {
      [CULTURE_PREFERENCE_CHOICES]: culturePreferenceData,
      [CULTURE_PREFERENCE_TYPE]: _teamTypePreference,
      [CULTURE_PREFERENCE_SCORE]: _teamTypePreferenceScore,
    };
  }
  return null;
};

export const updateJobSeekerData = async () => {
  const culturePreferenceData = getLocalStorageData();
  if (culturePreferenceData) {
    const _submittedData: any = {
      [CULTURE_PREFERENCE]: {
        [CULTURE_PREFERENCE_CHOICES]:
          culturePreferenceData[CULTURE_PREFERENCE_CHOICES],
        [CULTURE_PREFERENCE_TYPE]:
          culturePreferenceData[CULTURE_PREFERENCE_TYPE],
        [CULTURE_PREFERENCE_SCORE]:
          culturePreferenceData[CULTURE_PREFERENCE_SCORE],
      },
    };
    const response = await updateJobSeekerProfile(_submittedData);
    if (response.status === 200) {
      removeLocalStorage(STORAGE_NAME);
      return true;
    }
    return false;
  }
  return false;
};
